import React from "react";
import "./profile-icon.css";

function ProfileIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
      >
        <defs></defs>
        <g transform="translate(-42.114 -98.957)">
          <g transform="translate(42 95)">
            <g transform="translate(0 3.791)">
              <circle
                className="profile-a"
                cx="15"
                cy="15"
                r="15"
                transform="translate(0.114 0.166)"
              />
              <g transform="translate(8.995 7.605)">
                <path
                  className="profile-b"
                  d="M14.349,27.64V25.926A3.426,3.426,0,0,0,10.922,22.5h-6A3.426,3.426,0,0,0,1.5,25.926V27.64"
                  transform="translate(-1.5 -12.221)"
                />
                <path
                  className="profile-b"
                  d="M13.6,7.926A3.426,3.426,0,1,1,10.176,4.5,3.426,3.426,0,0,1,13.6,7.926Z"
                  transform="translate(-3.752 -4.5)"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </>
  );
}

export default ProfileIcon;
